import { safeDefine } from "../../registration/safe-define.js";
import { VolumeIndicatorElement } from "../../ui/volume-indicator/element.js";
//#region src/define/ui/volume-indicator.ts
safeDefine(VolumeIndicatorElement);
//#endregion
